import React, {Component} from 'react';
import {
    Container,
    Row,
    Col,
    Progress, CustomInput
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import moment from "moment/moment";
import qs from 'qs';

import Button from '../../../shared/components/Button';
import MoneyDisplay from '../../../shared/components/MoneyDisplay';
import SearchableDataTable from '../../../shared/components/SearchableDataTable';
import DropdownButton from '../../../shared/components/DropdownButton';
import Pills from '../../../shared/components/Pills';
import {getAgencyIdsForPadlockExperiences} from '../../../config'

import {
  formatStatus,
  recursivelyLoadAllPages,
  emojiUrlForRating,
  dayIsInPast ,
  firstNonZeroOrOne,
  alphabeticallySort,
  textContains,
  statusSort,
  daysSinceEpoch
} from '../../../shared/utils';
import ExtendCampaignModal from "../../../shared/components/ExtendCampaignModal";
import Promise from "bluebird";

class ProviderCampaignList extends Component {
  constructor(props){
    super(props);

    this.state = {
      searchText:'',
      isLoading:false,
      currentlyShowing:25,
      filter:'Recent',
      isHoverBudget: {},
      extendModal: {isModalOpen:false, campaignId: undefined},
        isArchivedCampaignsLoaded:false,
        excludePadlockCampaigns: getAgencyIdsForPadlockExperiences().indexOf(props.preSelectedBrand.agencyId) === -1,
        allCampaignsLoaded: false
    };
  }

  componentDidMount(){
      this.loadData(this.state.excludePadlockCampaigns)
  }

  loadData(excludePadlockCampaigns){
      this.setState({isLoading:true});
      Promise.all([
          this.props.loadKPIsForAllCampaigns(excludePadlockCampaigns),
          this.props.loadCampaigns(excludePadlockCampaigns),
          this.props.loadBrands(0,100000),
      ])
          .then(() => this.setState({isLoading:false, allCampaignsLoaded: !excludePadlockCampaigns, items: this.getFilteredList(this.props.campaigns, this.state.filter, excludePadlockCampaigns)}))
          .catch(() => this.setState({isLoading:false}));
  }

  handleEditClickedWhilePaused(campaignId){
    this.props.revertCampaignToDraft(campaignId)
      .then(() => this.props.history.push(`/superadmin/tutorial/create/${campaignId}`))
  }

    balanceAccounts(campaign, additionalAmount, selectedIOs){
        console.log(selectedIOs)
        let promises = []
        let budget = additionalAmount
        for (let io of selectedIOs) {
            if (budget <= 0) {
                break
            }
            let amount = budget > io.amount ? io.amount : budget
            promises.push(this.props.addFundsToCampaignFromAgency(campaign.agencyId,null,campaign.id,amount, ''  + io.id))
            budget = io.amount - budget
        }
        return Promise.all(promises)
    }

  submitExtendClick(data){
    return this.balanceAccounts(data.campaign, data.additionalThresholdAmount, data.selectedIOs)
        .then(() => this.props.extendCampaign(data.campaignId, data.newLifetimeBudget, data.resumeDate, data.endDate))
      .then((res)=> {
        return new Promise((resolve, reject) => {
          resolve(res);
          this.setState({extendModal: {...this.state.extendModal, isModalOpen: false}})
        })
      })
      .then(()=> {
        this.props.loadCampaign(data.campaignId)
      })
  }

  handleExtendClick(campaign){
    const {id, lifetimeBudget, budgetSpent, launchDate, endDate, status} = campaign
    this.setState({
      extendModal:{
        ...this.state.extendModal,
        isModalOpen:true,
        campaignId: id,
          campaign: campaign,
        currentThreshold: lifetimeBudget,
        amountSpent: budgetSpent,
        launchDate: launchDate,
        endDate: endDate,
        status: status,
          // ios: this.props.ios.filter(io => io.accountId === campaign.agencyId),
        onSubmit: (data) => {
          return this.submitExtendClick(data)
        },
        onCancel : ()=>{this.setState({extendModal: {...this.state.extendModal, isModalOpen:false}})}
      }
    })
  }

  updateFilter(filter, excludePadlockCampaigns){
      if (!this.state.isArchivedCampaignsLoaded && filter === 'Archived') {

          this.setState({filter: filter, isLoading: true, isArchivedCampaignsLoaded: true, items: []})

          recursivelyLoadAllPages(this.props.loadArchivedCampaigns,100)
              .then(() =>  {
                  console.log('archived campaigns loaded')
                  this.setState({filter: filter, isLoading: false, items: this.getFilteredList(this.props.campaigns, filter, excludePadlockCampaigns)})
              })
              .catch(() => console.warn('archived campaigns loading failed'));
      } else {
          this.setState({filter: filter, items: this.getFilteredList(this.props.campaigns, filter, excludePadlockCampaigns)})
      }
  }

  getFilteredList(items, filter, excludePadlockCampaigns){
      if (excludePadlockCampaigns) {
          items = items.filter(item => getAgencyIdsForPadlockExperiences().indexOf(item.agencyId) === -1)
      }
    switch (filter) {
        case 'All':
            return items.filter(item => item.status !== 'archived')
        case 'Recent':
            const now = moment().startOf("day")
            return items.filter(item => item.status !== 'archived' && now.diff(moment(item.launchDate != null ? item.launchDate : item.lastModifiedDate).startOf("day"), 'days') < 90)
        case 'Active':
            return items.filter(item => item.status === 'active')
        case 'Archived':
            return items.filter(item => item.status === 'archived')
    }
    console.error('Filter Experiences by ' + filter + ' couldn\'t be handled')
    return items
  }

  handleExcludePadlockClicked(checked){
      this.setState({ excludePadlockCampaigns: checked})
      if (this.state.allCampaignsLoaded){
          this.updateFilter(this.state.filter, checked)
          return
      }
      this.loadData(checked)
  }

  renderFilterSection(){
      const {excludePadlockCampaigns, isLoading} = this.state
    return <Row>
      <Col xs='7'>
        <Pills
          selected={this.state.filter}
          onChange={(filter) => this.updateFilter(filter, excludePadlockCampaigns)}
          states={['Recent','Active','All','Archived']}
          titles={['Recent','Active','All','Archived']}
      />
    </Col>
        {!this.props.brandId &&
        <Col xs='5'>
            <CustomInput type="checkbox" id="includePadlockCampaigns"
                         label="Include Dabbl Research Locked Experiences" inline
                         disabled={isLoading}
                         checked={!excludePadlockCampaigns}
                         onChange={(e) => this.handleExcludePadlockClicked(!e.target.checked)}/>
        </Col>
        }
    </Row>

  {/*return <ButtonGroup className='searchable-table_filter-buttons'>*/}
      {/*<Button color='link' active={this.state.filter === 'Recent'} onClick={()=>this.updateFilter('Recent')}>Recent</Button>*/}
      {/*<Button color='link' active={this.state.filter === 'Active'} onClick={()=>this.updateFilter('Active')}>Active</Button>*/}
      {/*<Button color='link' active={this.state.filter === 'All'} onClick={()=>this.updateFilter('All')}>All</Button>*/}
    {/*</ButtonGroup>*/}
  }

  budgetValue(campaign, budgetProgress){
    const isHoveredItem = this.state.isHoverBudget[campaign.id] === true;
    return (
      <div>
        <Progress
          className='BudgetProgressBar'
          value={(budgetProgress / campaign.lifetimeBudget) * 100}
        />
        <small
          onMouseEnter={() => this.setState({isHoverBudget:{...this.state.isHoverBudget, [campaign.id]: true }})}
          onMouseLeave={() => this.setState({isHoverBudget:{...this.state.isHoverBudget, [campaign.id]: false }})}>
          <MoneyDisplay>{Math.abs(isHoveredItem ? budgetProgress : campaign.lifetimeBudget - budgetProgress)}</MoneyDisplay>
          &nbsp;{ isHoveredItem ? 'spent' : (campaign.lifetimeBudget - budgetProgress) > 0 ? 'remaining' : 'over budget'}
        </small>
      </div>
    )
  }


  renderButtonsForCampaign(campaign){
    const endDateInPast = campaign.endDate && dayIsInPast(campaign.endDate);

    if(campaign.status === 'draft'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/tutorial/create/${campaign.id}${this.props.brandId ? `?brandId=${this.props.brandId}` : ''}`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Edit
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              },
                {
                    text:'Archive',
                    onClick:() => this.props.archiveCampaign(campaign.id)
                }
            ]}
          />
        </div>
      );
    }

    if(campaign.status === 'pendingAdjoy' || campaign.status === 'pendingAgency'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/experiences/${campaign.id}/review`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Review
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      );
    }

    if(campaign.status === 'active' || campaign.status === 'ready'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/experiences/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Extend',
                onClick:() => this.handleExtendClick(campaign)
              },
              {
                text:'Pause',
                confirmationText:'Users will not be able to view or complete this experience.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.suspendCampaign(campaign.id)
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              }
            ]}
          />
        </div>
      );
    }

    if(campaign.status === 'suspended' && endDateInPast){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/experiences/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Edit',
                onClick:() => this.handleEditClickedWhilePaused(campaign.id)
              },
              {
                text:'Resume',
                confirmationTitle:'Sorry',
                confirmationText:'End date cannot be in the past. Please update end date before resuming.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => {}
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              },
                {
                    text:'Archive',
                    onClick:() => this.props.archiveCampaign(campaign.id)
                }
            ]}
          />
        </div>
      )

    }

    if(campaign.status === 'suspended' && !endDateInPast){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/experiences/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Edit',
                onClick:() => this.handleEditClickedWhilePaused(campaign.id)
              },
              {
                text:'Resume',
                confirmationText:'Users will be now able to complete this experience and earn rewards.',
                confirmationAcceptText:'Confirm',
                confirmationRejectText:'Cancel',
                onClick:() => this.props.resumeCampaign(campaign.id)
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              },
                {
                    text:'Archive',
                    onClick:() => this.props.archiveCampaign(campaign.id)
                }
            ]}
          />
        </div>
      )

    }

    if(campaign.status === 'outOfFunds' || campaign.status === 'complete'){
      return (
        <div className='pull-right'>
          <Button
            linkHref={`/superadmin/experiences/${campaign.id}/reports`}
            size='sm'
            textColor='#666666'
            borderColor='#cccccc'
            backgroundColor='#fff'
          >
            Results
          </Button>
          &nbsp;&nbsp;
          <DropdownButton
            options={[
              {
                text:'Extend',
                onClick:() => this.handleExtendClick(campaign)
              },
              {
                text:'Duplicate',
                onClick:() => this.props.duplicateCampaign(campaign.id)
              },
                {
                    text:'Archive',
                    onClick:() => this.props.archiveCampaign(campaign.id)
                }
            ]}
          />
        </div>
      );
    }
      if(campaign.status === 'archived'){
          return (
              <div className='pull-right'>
                  <Button
                      linkHref={`/superadmin/experiences/${campaign.id}/reports`}
                      size='sm'
                      textColor='#666666'
                      borderColor='#cccccc'
                      backgroundColor='#fff'
                  >
                      Results
                  </Button>
                  &nbsp;&nbsp;
                  <DropdownButton
                      options={[
                          {
                              text:'Duplicate',
                              onClick:() => this.props.duplicateCampaign(campaign.id)
                          },
                          {
                              text:'Delete',
                              confirmationText:'This is permanent and can not be reverted.',
                              confirmationAcceptText:'Confirm',
                              confirmationRejectText:'Cancel',
                              onClick:() => this.props.deleteCampaign(campaign.id)
                          }
                      ]}
                  />
              </div>
          );
      }

    return null;
  }

  renderName(name){
    if(!name || name === 'Untitled campaign' || name === 'Unknown brand'){
      return <i>{name}</i>
    } else {
      return name;
    }
  }

  render(){
    const { campaigns } = this.props;
    const { isLoading, excludePadlockCampaigns } = this.state;
    const filteredCampaigns = this.getFilteredList(campaigns, this.state.filter, excludePadlockCampaigns)
    const search = qs.parse(this.props.location.search, { strictNullHandling: true, ignoreQueryPrefix: true  }).search;

    return (
      <Container className='ProviderCampaignListTable'>
        <ExtendCampaignModal {...this.state.extendModal}/>
        <Row className='EntityList-title'>
          <Col xs='6'>
            <h1>
              Experiences
            </h1>
          </Col>
          <Col xs='6'>
            <Button
              className='pull-right'
              linkHref={`/superadmin/tutorial/create/new${this.props.brandId ? `?brandId=${this.props.brandId}` : ''}`}
            >
              Create Experience
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <SearchableDataTable
              history={this.props.history}
              search={search}
              items={isLoading ? [] : filteredCampaigns}
              emptyText={isLoading ? 'Loading experiences...' : 'No experiences'}
              searchPromptText='Search by name or brand'
              getFilterSection={() => this.renderFilterSection()}
              defaultSortColumn={'startdate'}
              defaultSortFunc={(a,b) => firstNonZeroOrOne([
                (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                alphabeticallySort(a.name,b.name),
                statusSort(a.status, b.status)
              ])}
              columns={[
                {
                  name:'status',
                  width:12,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    alphabeticallySort(formatStatus(a.status), formatStatus(b.status)),
                    (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (<span>{formatStatus(item.status)}</span>)
                },

                {
                  display:'Start Date',
                  name:'startdate',
                  width:12,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                    alphabeticallySort(a.name,b.name),
                    statusSort(a.status, b.status)
                  ]),
                  renderCell:(item) => (
                    <span>
                      {item.launchDate != null ? moment(item.launchDate).format('MMM D, YYYY') : ""}
                    </span>
                  )
                },
                {
                  display:'Experience',
                  name:'name',
                  width:25,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    alphabeticallySort(a.name,b.name),
                    (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                  ]),
                  filterFunc:(a,searchParam) => textContains(a.name,searchParam) || textContains(a.brandName,searchParam),
                  renderCell:(item) => (
                    <div>
                      <h6>
                        <Link to={`/superadmin/experiences/${item.id}/review`}>
                          {this.renderName(item.name)}
                        </Link>
                      </h6>
                      <strong className='BreakWordOnWrap'>
                        {this.renderName(item.brandName)}
                      </strong>
                      <br />
                      <span>Experience <strong>#{item.salesNumber}</strong></span>
                    </div>
                  )
                },
                  {
                      display:'Priority',
                      name:'priority',
                      width:10,
                      sortFunc:(a,b) => firstNonZeroOrOne([
                          b.priority - a.priority,
                          (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                          alphabeticallySort(a.name,b.name)
                      ]),
                      renderCell:(item) => (<span>{item.priority === 9 ? 'Default' : item.priority}</span>)
                  },
                {
                  display:'Completions',
                  name:'numCompletions',
                  width:16,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    b.numCompletions - a.numCompletions,
                    (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (<span>{item.isOrHasBeenLive && item.numCompletions.toLocaleString()}</span>)
                },
                {
                  display:'CTR',
                  name:'ctRate',
                  width:13,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    b.ctRate - a.ctRate,
                    (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (
                    <div>
                      {(item.isOrHasBeenLive && item.numCompletions > 0) && (
                          <span>{(item.ctRate).toFixed(2)}%</span>
                      )}
                      {(item.isOrHasBeenLive && item.numCompletions === 0) && (
                        <span>N/A</span>
                      )}
                    </div>
                  )
                },
                {
                  display:'Budget',
                  name:'lifetimeBudget',
                  width:17,
                  sortFunc:(a,b) => firstNonZeroOrOne([
                    parseFloat(b.lifetimeBudget || 0) - parseFloat(a.lifetimeBudget || 0),
                    (b.launchDate != null ? b.launchDate : b.lastModifiedDate) - (a.launchDate != null ? a.launchDate : a.lastModifiedDate),
                    alphabeticallySort(a.name,b.name)
                  ]),
                  renderCell:(item) => (
                    <div>
                      <MoneyDisplay>{item.lifetimeBudget}</MoneyDisplay>
                      {item.isOrHasBeenLive && (
                        this.budgetValue(item, item.budgetSpent)
                      )}
                    </div>
                  )
                },
                {
                  width:20,
                  renderCell:(item) => this.renderButtonsForCampaign(item)
                }
              ]}
            />
            <br />
            <br />
            <br />
          </Col>
        </Row>
      </Container>
    )
  }
}

export default ProviderCampaignList;



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignList/components/ProviderCampaignList.js